export const environment = {
    production: true,

    // urlWhats: 'http://localhost:3801/api',
    // urlWhatsWs: 'http://localhost:3801/',
    // urlWha: 'http://localhost:3801/',
    urlWhatsMasivos: "",

    //------ Kaloni --------
    // urlWhats: 'https://kaloni.iatich.de/backend/api',
    // urlWhatsWs: 'https://kaloni.iatich.de/',
    // urlWha: 'https://kaloni.iatich.de/backend/',

    //------ Kaloni Colombia --------
    // urlWhats: 'https://kalonicolombia.iatich.de/backend/api',
    // urlWhatsWs: 'https://kalonicolombia.iatich.de/',
    // urlWha: 'https://kalonicolombia.iatich.de/backend/',

    //------ Kaloni Medicina Regenerativa --------
    //  urlWhats:'https://medicina-regenerativa.iatich.de/backend/api',
    //  urlWhatsWs:'https://medicina-regenerativa.iatich.de/',
    //  urlWha: 'https://medicina-regenerativa.iatich.de/backend/api/',

    //------ Consubanco --------
    // urlWhats:'https://bodegasbdm2.iatich.de/backend/api',
    // urlWhatsWs:'https://bodegasbdm2.iatich.de/',
    // urlWha: 'https://bodegasbdm2.iatich.de/backend/',

    //------ Consubanco Secundario --------
    // urlWhats:'https://clearvoice2.iatich.de/backend/api',
    // urlWhatsWs:'https://clearvoice2.iatich.de/',
    // urlWha: 'https://clearvoice2.iatich.de/backend/',

    //------ Consubanco 3 --------
    // urlWhats:'https://clearvoice3.iatich.de/backend/api',
    // urlWhatsWs:'https://clearvoice3.iatich.de/',
    // urlWha: 'https://clearvoice3.iatich.de/backend/',

    //------ Consubanco 4 --------
    // urlWhats:'https://bodegas.iatich.de/backend/api',
    // urlWhatsWs:'https://bodegas.iatich.de/',
    // urlWha: 'https://bodegas.iatich.de/backend/',

    // -------AS ------------
    // urlWhats: 'https://backVabbel.planitondemand.com.mx/api',
    // urlWhatsWs: 'https://backVabbel.planitondemand.com.mx/',
    // urlWha: 'https://backVabbel.planitondemand.com.mx/',

    // -------Vabbel ------------
    // urlWhats: 'https://as-backend.planitondemand.com.mx/api',
    // urlWhatsWs: 'https://as-backend.planitondemand.com.mx/',
    // urlWha: 'https://as-backend.planitondemand.com.mx/',

    //----------waldos--------
    urlWhats: "https://waldos.iatich.de/backend/api",
    urlWhatsWs: "https://waldos.iatich.de/",
    urlWha: "https://waldos.iatich.de/backend/",

    //----------waldos 2--------
    //urlWhats: "https://waldos2.iatich.de/backend/api",
    //urlWhatsWs: "https://waldos2.iatich.de/",
    //urlWha: "https://waldos2.iatich.de/backend/",

    //----------Planet Fitness--------
     //urlWhats: "https://planet.iatich.de/backend/api",
     //urlWhatsWs: "https://planet.iatich.de/",
     //urlWha: "https://planet.iatich.de/backend/",

    //------boston------------
    // urlWhats :"https://channel.iatich.de/boston/api",
    // urlWhatsWs:"https://channel.iatich.de/",
    // urlWha: "https://channel.iatich.de/boston/",
    // urlWhatsMasivos: "https://channel.iatich.de/masivos/api",

    //------ IKE -----
    //urlWhats :"https://ike.iatich.de/multicanal/api",
    //urlWhatsWs:"https://ike.iatich.de/",
    //urlWha: "https://ike.iatich.de/multicanal/",

    //------ IKE Colombia -----
    // urlWhats :"https://ikecolombia.iatich.de/backend/api",
    // urlWhatsWs:"https://ikecolombia.iatich.de/",
    // urlWha: "https://ikecolombia.iatich.de/backend/",

    //-------------Goapps------------------
    // urlWhats :"https://checkingfleet.iatich.de/backend/api",
    // urlWhatsWs:"https://checkingfleet.iatich.de/",
    // urlWha: "https://checkingfleet.iatich.de/backend/",

    //------------- bene ------------------
     //urlWhats :"https://bene.iatich.de/backend/api",
     //urlWhatsWs:"https://bene.iatich.de/",
     //urlWha: "https://bene.iatich.de/backend/",

    // ---------- Punto clinico ------------
    //  urlWhats: "https://pc-backend.planitondemand.com.mx/api",
    //  urlWhatsWs: "https://pc-backend.planitondemand.com.mx/",
    //  urlWha: "https://pc-backend.planitondemand.com.mx/",

    //------------- Docker test -------------
    // urlWhats: 'https://backVabbel.planitondemand.com.mx/api',
    // urlWhatsWs: 'https://backVabbel.planitondemand.com.mx/',
    // urlWha: 'https://backVabbel.planitondemand.com.mx/',

    //------ Kaloni Docker --------
    // urlWhats: 'https://kaloni-backend.planitondemand.com.mx/api',
    // urlWhatsWs: 'https://kaloni-backend.planitondemand.com.mx/',
    // urlWha: 'https://kaloni-backend.planitondemand.com.mx/',

    // urlWhats: 'https://barbering.iatich.de/botwa/api',
    url: 'https://barbering.iatich.de/cdmx/api',
    storageUrl: 'https://barbering.iatich.de/storage/',
    urlPy: 'https://6htpaqttlldqwcpiciss2sa7wa0wgyhf.lambda-url.us-east-1.on.aws/',
    // mapKeyApi: "AIzaSyAhy7AzaREqAVZuW_cx-XYpVHSgYtkyKvo"
    // urlRostros: 'http://localhost:3500'
    // urlWhats: 'https://channel.iatich.de/boston/api',
    // urlWhatsWs: 'https://channel.iatich.de/',
    urlRostros: 'https://barbering.iatich.de/gpsrasspertech'
};
